/**
 * Тело пишущей команды 1С (business-contract-v1): версия договора, схема
 * действия, ожидаемая ревизия, данные, operationId и ключ идемпотентности.
 * Ключ и operationId создаются ОДИН раз на намерение человека и переиспользуются
 * при «Проверить исход» — служба по тому же ключу отдаёт прежний итог или
 * выясняет его чтением, второй записи не будет (ADR-11).
 */
export const ONEC_CONTRACT_VERSION = '1.0'

export interface WriteCommandIdentity {
  operationId: string
  idempotencyKey: string
  expectedConfigurationVersion: string
}

export function writeCommandBody(schemaVersion: string, identity: WriteCommandIdentity, data: unknown) {
  return {
    contractVersion: ONEC_CONTRACT_VERSION,
    schemaVersion,
    expectedConfigurationVersion: identity.expectedConfigurationVersion,
    data,
    operationId: identity.operationId,
    idempotencyKey: { value: identity.idempotencyKey },
  }
}
